
'use client';
import Link from 'next/link';
import NextImage from '../Image';

export interface TestimonialProductData {
  id: number;
  thumbnail_image: string | null;
  name: string;
  slug: string;
  price: number;
  sale_price: number;
}

export const TestimonialProduct = ({ product }: { product: TestimonialProductData }) => {
  const hasDiscount = product.sale_price < product.price;

  return (
    <Link href={`/product/${product.slug}`} className="testimonial__product-link">
      <div className="mini-product-card">
        <div className="mini-product-thumb">
          <NextImage 
            // API uses thumbnail_image. If null, use fallback
            src={product.thumbnail_image || "/images/product/demo-product.png"} 
            alt={product.name} 
            width={60} 
            height={60} 
            className="object-fit-contain"
          />
        </div>
        
        <div className="mini-product-info">
          <p className="product-name">{product.name}</p>
          <div className="product-price">
            <span className="current">৳{product.sale_price}</span>
            {hasDiscount && (
              <span className="discount"> 
                {' / '}<del>৳{product.price}</del>
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};